import { OperatorFunction, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { IDisposable } from './disposable.interface';

export class NotifyPropertyChangedEvent<T> {
  constructor(public readonly propertyName: keyof T) {}
}

export abstract class NotifyPropertyChanged<T> implements IDisposable {
  private readonly propertyChanged = new Subject<NotifyPropertyChangedEvent<T>>();

  public readonly propertyChanged$ = this.propertyChanged.asObservable();

  public dispose() {
    this.propertyChanged.complete();
  }

  protected notifyPropertyChanged(propertyName: keyof T) {
    this.propertyChanged.next(new NotifyPropertyChangedEvent(propertyName));
  }
}

export function ofPropertyNames<T>(
  ...propertyNames: (keyof T)[]
): OperatorFunction<NotifyPropertyChangedEvent<T>, NotifyPropertyChangedEvent<T>> {
  return filter((event: NotifyPropertyChangedEvent<T>) => {
    if (!propertyNames?.length) {
      return false;
    }

    return propertyNames.includes(event.propertyName);
  });
}
